"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _Fonts = require("../00_environment/Fonts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LinkButton = function LinkButton(_ref) {
  var style = _ref.style,
      to = _ref.to,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: to,
    style: Object.assign((0, _Fonts.withLinkButtonFont)({
      textDecoration: 'none',
      cursor: 'pointer'
    }), style || {})
  }, children);
};

var _default = LinkButton;
exports["default"] = _default;